import React, { useReducer, useEffect, useState, useRef } from 'react';
import * as actions from '../../../actions/dashboard';
import dashboardReducer from '../../../reducers/dashboard';
import SafetyAlert from '../safetyAlert/SafetyAlert';
import { confirm } from 'devextreme/ui/dialog';
import logoImg from './assets/noAttachment.png'
import corruptedImg from './assets/CORRUPTEDFILE.jpg'
import { Toast } from 'devextreme-react/toast';
import pdfImg from './assets/pdfImg.png'
import pptImg from './assets/pptImg.png'
import excelImg from './assets/excelImg.png'
import wordImg from './assets/wordImg.png';
import { getTypeOfFile } from '../../../common/utils';


const initialState = { messages: [], alerts: [] }
export default ({ siteId, tierId, type, data, key, isEditable }) => {
    const basePath = window.location.origin;
    const [state, dispatch] = useReducer(dashboardReducer, initialState);
    const { messages, alerts } = state
    const [showMsgs, setMsgs] = useState(true)
    const [editView, setEditView] = useState(false)
    const [message, setMessage] = useState('');
    const [uploadedFile, setUploadedFile] = useState([]);
    const [activeAlert, setActiveAlert] = useState(false);
    const [showNewWin, setShowNewWin] = useState(false)
    const [typeEditView, setTypeEditView] = useState({
        type: type,
        editView: false
    });
    const [url, setUrl] = useState(null)
    const [toastConfig, setToastConfig] = useState({
        isVisible: false,
        type: 'info',
        message: '',
    });

    const handleMsgDisplay = () => setMsgs(!showMsgs)
    const saveMsg = () => {
        let data = {
            "crud": "ALTER",
            "sitecode": siteId,
            "tierid": tierId,
            "safetymessage": message,
            "safetymessagefilepath": "",
            "sqdcp": type
        }
        actions.updateMessages(dispatch, data)
        setTypeEditView({
            type: type,
            editView: false
        });
    }
    const setEditValue = (a, b) => {
        setTypeEditView({ type: a, editView: b });
    }
    const revertMsg = () => {
        let updatedMessage = data.title;
        setMessage({ message: updatedMessage })
        let updatedData = {
            "crud": "REVERT",
            "sitecode": siteId,
            "tierid": tierId,
            "safetymessage": updatedMessage,
            "safetymessagefilepath": "",
            "sqdcp": type
        }
        actions.updateMessages(dispatch, updatedData)
        setTypeEditView({
            type: type,
            editView: false
        });
    }

    const cancelView = () => {
        setMessage('')
        setTypeEditView({ type: type, editView: false });
    }

    const [show, setShow] = useState(false)

    const saveInfo = () => { }

    const showInfo = (data) => {
        setActiveAlert(data)
        setShow(true)
    }

    const hideInfo = () => {
        setShow(false)
    }

    const apiProps = `siteId=${siteId}&tierId=${tierId}&sqdcp=${type}&title=${data.title}`
    const getMessageDetails = (apiProps) => {
        actions.getMessages(dispatch, apiProps);
        setMessage('')
        setTypeEditView({
            type: type,
            editView: false
        });
    }
    useEffect(() => {
        actions.getAlerts(dispatch, apiProps);
        getMessageDetails(apiProps);
    }, [type])

    const getAlerts = () => {
        actions.getAlerts(dispatch, apiProps);
        getMessageDetails(apiProps);
    }

    function onHiding() {
        setToastConfig({
            ...toastConfig,
            isVisible: false,
        });
    }

    const updateAlertInfo = (data) => {
        data.append('sitecode', siteId)
        data.append('tierId', tierId)
        data.append('archive', "N")
        data.append('alertType', type)
        setShow(false);
        actions.updateAlerts(dispatch, data, apiProps)
    }

    const delAlert = (data) => {
        confirm("Are you sure you want to delete this record?", "Confirm changes")
            .then(async (res) => {
                if (res) {
                    let formData = new FormData();
                    formData.append('id', data.id)
                    formData.append('sitecode', siteId)
                    formData.append('tierId', tierId)
                    formData.append('archive', "Y")
                    formData.append('alertType', type)

                    await actions.updateAlerts(dispatch, formData, apiProps)
                    setToastConfig({
                        ...toastConfig,
                        isVisible: true,
                        type: 'success',
                        message: 'Alert Removed Successfully!!'
                    });
                }

            });
    }


    const getThumbnail = (data) => {
        let fileType = data.fileExtension.toLowerCase();
        switch (fileType) {
            case 'gif':
            case 'png':
            case 'jfif':
            case 'jpg':
            case 'jpeg':
                return <img className="alert-img" src={data.fileStream} />
            case 'ppt':
            case 'pptx':
                return <img className="alert-img" src={pptImg} />
            case 'pdf':
                return <img className="alert-img" src={pdfImg} />
            case 'excel':
            case 'xlsx':
            case 'csv':
            case 'xls':
            case 'xlt':
            case 'xltm':
                return <img className="alert-img" src={excelImg} />
            default:
                return <img className="alert-img" src={logoImg} />
        }
    }
            //case 'doc': 
            //case 'docx':
            //    return <img className="alert-img" src={wordImg} />

    const alertConfig = {
        hideInfo: () => setShow(false),
        show: show,
        showInfo: showInfo,
        updateAlertInfo: updateAlertInfo,
        tpl: data,
        activeAlert: activeAlert,
        popupTitle: `${data.title}`,
        getCall: getAlerts
    }


    return (
        <>
            <div className="col mr-r-0" id={type} >
                <div className="col-heading">
                    <div className="safety-msg-block" id={type}>
                        <span className="txt-left w-80">
                            <i className="fas fa-exclamation" ></i>

                            {((typeEditView.type === type) && typeEditView.editView)
                                ?
                                <input type="text" value={message.message === data.title ? "" : message} onChange={e => setMessage(e.target.value)} placeholder={`${data.title} Message...`} />
                                :
                                <span >{messages[0] && messages[0]['message']}</span>
                            }
                        </span>
                        <span className="safety-msg-actions">
                            {(typeEditView.type === type && typeEditView.editView) ?
                                <>
                                    <i className="fas fa-save safetyAlertMessage" title="Save Message" onClick={saveMsg} ></i>
                                    {messages[0] && !(messages[0]['message'] === data.title) ?
                                        <i className="fas fa-undo safetyAlertMessage" title="Revert Message" onClick={revertMsg} ></i>
                                        : ''}
                                    <i className="fas fa-times safetyAlertMessage" title="Cancel" onClick={() => setTypeEditView({ type: type, editView: false })}></i>
                                </>
                                : <>
                                    {isEditable ? <i className="fas fa-pencil-alt safetyAlertMessage" onClick={() => setTypeEditView({ type: typeEditView.type, editView: true })} title="Edit Message" ></i> : ''}</>
                            }

                            {isEditable && <i className="fas fa-plus safetyAlert" title="Add Alert" onClick={() => showInfo(false)} ></i>}

                            {showMsgs ? <i className="fas fa-chevron-up" onClick={handleMsgDisplay} title="Collapse" ></i> : <i className="fas fa-chevron-down" onClick={handleMsgDisplay} title="Expand" ></i>}
                        </span>
                    </div>
                </div>
                <div className={showMsgs ? "col-body " : "col-body hide"}>
                    <div className="alerts-flex-container">
                        {
                            alerts.map((data, i) => {
                                return <div key={i} className="safety-alert-card">
                                <div className="alert-container" title={`Title : ${data.messageTitle} | Description : ${data.messageDescription} | Posted Date: ${data.createdDate}`}>
                                    <div >
                                        {
                                            data.imageName
                                                ? (data.imageName === "CORRUPTED")
                                                    ? <a title="Corrupted File" className="no-link" disabled>
                                                        {
                                                            getThumbnail(data)
                                                        }
                                                    </a>

                                                    : <a onClick={() => {
                                                        data.fileExtension = data.fileExtension == 'xls' ? 'xlsx' : data.fileExtension
                                                        getTypeOfFile(data, 'Sites')
                                                    }}>
                                                        {
                                                            getThumbnail(data)
                                                        }
                                                    </a>
                                                : <a title="No Attachment" className="no-link" disabled>
                                                    {
                                                        getThumbnail(data)
                                                    }
                                                </a>
                                        }
                                    </div>
                                    <div className="txt-episis" >
                                        <label className="alert-label">{data.messageTitle}</label>
                                    </div>
                                    <div style={{ "minWidth": "50px" }}>
                                        {isEditable && <>
                                            <i className="fas fa-pencil-alt" title="Edit Alert" onClick={() => showInfo(data)}></i>
                                            <i title="Delete Alert" className="fas fa-trash" onClick={() => delAlert(data)} ></i>
                                        </>}</div>
                                </div>
                            </div>
                            }
                            )
                        }
                    </div>
                </div>
            </div>
            <SafetyAlert {...alertConfig} />
            <Toast
                visible={toastConfig.isVisible}
                message={toastConfig.message}
                type={toastConfig.type}
                onHiding={onHiding}
                displayTime={2000}
            />
        </>
    )
}